
const Alarm = (props) => (
  <svg
    viewBox="0 0 512 512"
    fill="#ffffff"
    width="30px"
    height="30px"
    {...props}
  >
    <path d="M256,43.91s-144,158.3-144,270.3c0,88.36,55.64,144,144,144s144-55.64,144-144C400,202.21,256,43.91,256,43.91Zm16,362.3v-24a60.07,60.07,0,0,0,60-60h24A84.09,84.09,0,0,1,272,406.21Z" />
  </svg>
);

export default Alarm;
